<div class="modal-header">
    <h5 class="modal-title mb-0 sd-text-primary">Product List</h5>
    <button type="button" class="btn-close custom-close-btn" aria-label="Close" (click)="cancelPopup()"></button>
</div>

<div class="modal-body text-center py-4">
    <!-- <div class="table-responsive mb-2">
        <h5 class="mb-0 sd-text-primary text-start">Product Details</h5>
        <table class="table table-bordered table-hover align-middle text-nowrap">
            <thead class="custom-header">
                <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Store Name</th>
                    <th>Tag</th>
                    <th>Invoice No</th>
                    <th>Style No</th>
                    <th>Bag No</th>
                    <th>Net Wt</th>
                    <th>Metal KT</th>
                    <th>Category Name</th>
                    <th>Gross Wt</th>
                    <th>Certificate No</th>
                    <th>HUID</th>
                    <th>MRP Type</th>
                    <th>Selling Price</th>
                    <th>Dp Price</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of paginatedProductData; let i = index">
                    <td>{{ (productCurrentPage - 1) * itemsPerPage + i + 1 }}</td>
                    <td><img [src]="data.image" alt="Product Image" style="max-width: 50px; max-height: 50px;"
                            (click)="getProductDetails(data)" /></td>
                    <td>{{ data.storeName }}</td>
                    <td>{{ data.tag }}</td>
                    <td>{{ data.invoiceNo }}</td>
                    <td>{{ data.styleNo }}</td>
                    <td>{{ data.bagNo }}</td>
                    <td>{{ data.netWt }}</td>
                    <td>{{ data.metalKT }}</td>
                    <td>{{ data.categoryName }}</td>
                    <td>{{ data.grossWt }}</td>
                    <td>{{ data.certificateNo }}</td>
                    <td>{{ data.huid }}</td>
                    <td>{{ data.mrpType }}</td>
                    <td>{{ data.sellingPrice }}</td>
                    <td>{{ data.dpPrice }}</td>
                </tr>
                <tr *ngIf="(productDetails?.length ?? 0) === 0">
                    <td colspan="16" class="text-center">No Data Available</td>
                </tr>
            </tbody>
        </table>
        <div class="row justify-content-between align-items-center mt-2 pt-2" *ngIf="(productDetails?.length ?? 0) > 0">
            <div class="col-md-6 col-lg-4">
                <pagination [page]="productCurrentPage" [totalItems]="productDetails.length"
                    [itemsPerPage]="itemsPerPage" [maxSize]="5" [rotate]="false" [boundaryLinks]="true"
                    previousText="&lsaquo;" nextText="&rsaquo;" (pageChanged)="onProductPageChanged($event)">
                </pagination>
            </div>
        </div>
    </div> -->
    <hr />
    <div class="table-responsive">
        <h5 class="mb-0 sd-text-primary text-start">Invoice Details</h5>
        <table class="table table-bordered table-hover align-middle text-nowrap">
            <thead class="custom-header">
                <tr>
                    <th></th>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Invoice Date</th>
                    <th>Store Name</th>
                    <th>Invoice Amount</th>
                    <th>Customer MobileNo</th>
                    <th>Customer Name</th>
                    <th>Customer Code</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of paginatedInvoiceData; let i = index">
                    <td>
                        <input type="checkbox" [checked]="isInvoiceSelected(data)"
                            (change)="onInvoiceCheckChange($event, data)" />
                    </td>
                    <td>{{ (invoiceCurrentPage - 1) * itemsPerPage + i + 1 }}</td>
                    <td>{{ data.invoiceNo }}</td>
                    <td>{{ data.invoiceDate | date:'dd/MM/yyyy' }}</td>
                    <td>{{ data.storeName }}</td>
                    <td>{{ data.invoiceAmount }}</td>
                    <td>{{ data.customerMobileNo }}</td>
                    <td>{{ data.customerName }}</td>
                    <td>{{ data.customerCode }}</td>
                    <td>
                        <button style="border:none; background:none; color:#232B6E;" title="View Invoice Details"
                            (click)="viewInvoiceDetails(data)">
                            <i class="fa fa-eye"></i>
                        </button>
                    </td>
                </tr>
                <tr *ngIf="(invoiceDetails?.length ?? 0) === 0">
                    <td colspan="10" class="text-center">No Data Available</td>
                </tr>
            </tbody>
        </table>
        <div class="row justify-content-between align-items-center mt-2 pt-2" *ngIf="(invoiceDetails?.length ?? 0) > 0">
            <div class="col-md-6 col-lg-4">
                <pagination [page]="invoiceCurrentPage" [totalItems]="invoiceDetails.length"
                    [itemsPerPage]="itemsPerPage" [maxSize]="5" [rotate]="false" [boundaryLinks]="true"
                    previousText="&lsaquo;" nextText="&rsaquo;" (pageChanged)="onInvoicePageChanged($event)">
                </pagination>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center gap-2 mt-3" *ngIf="(invoiceDetails?.length ?? 0) > 0">
        <button type="button" class="btn sd-custom-btn btn-sm px-4" [disabled]="!selectedInvoiceNo"
            (click)="onReturnAction('RETURN')">Return</button>
        <button type="button" class="btn sd-custom-btn btn-sm px-4" [disabled]="!selectedInvoiceNo"
            (click)="onReturnAction('BUYBACK')">Buy Back</button>
        <button type="button" class="btn sd-custom-btn btn-sm px-4" [disabled]="!selectedInvoiceNo"
            (click)="onReturnAction('EXCHANGE')">Exchange</button>
    </div>

    <hr />
    <!-- <div class="table-responsive">
        <h5 class="mb-0 sd-text-primary text-start">Customer Details</h5>
        <table class="table table-bordered table-hover align-middle text-nowrap">
            <thead class="custom-header">
                <tr>
                    <th>#</th>
                    <th>Customer Code</th>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th>Gender</th>
                    <th>Email</th>
                    <th>PAN Card No</th>
                    <th>Address</th>
                    <th>Credit Amt</th>
                    <th>Created On</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of paginatedCustomerData; let i = index">
                    <td>{{ (customerCurrentPage - 1) * itemsPerPage + i + 1 }}</td>
                    <td>{{ data.customerCode }}</td>
                    <td>{{ data.firstName }}</td>
                    <td>{{ data.mobileNo }}</td>
                    <td>{{ data.gender }}</td>
                    <td>{{ data.email }}</td>
                    <td>{{ data.panCardNo }}</td>
                    <td>{{ data.address }}</td>
                    <td>{{ data.creditAmt | number:'1.2-2' }}</td>
                    <td>{{ data.createdOn | date:'dd/MM/yyyy' }}</td>
                </tr>
                <tr *ngIf="(customerDetails?.length ?? 0) === 0">
                    <td colspan="9" class="text-center">No Data Available</td>
                </tr>
            </tbody>
        </table>
        <div class="row justify-content-between align-items-center mt-2 pt-2"
            *ngIf="(customerDetails?.length ?? 0) > 0">
            <div class="col-md-6 col-lg-4">
                <pagination [page]="customerCurrentPage" [totalItems]="customerDetails.length"
                    [itemsPerPage]="itemsPerPage" [maxSize]="5" [rotate]="false" [boundaryLinks]="true"
                    previousText="&lsaquo;" nextText="&rsaquo;" (pageChanged)="onCustomerPageChanged($event)">
                </pagination>
            </div>
        </div>
    </div> -->
</div>